const CAROUSEL_GLIDER_DRAGGABLE = ".carousel__items.glider";
const IMG = "img";
const DISPLAY_NONE = "none";


const initCarousel = () => {
    const carouselGliders = document.querySelectorAll(CAROUSEL_GLIDER_DRAGGABLE);
    iterateGliders(carouselGliders);
}

const iterateGliders = (carouselGliders) => {
    for (const carouselGlider of carouselGliders) {
        const imageTags = carouselGlider.getElementsByTagName(IMG);
        if (imageTags.length === 1) {
            hideSiblings(carouselGlider);
        }
    }
}

const hideSiblings = (carouselGliders) => {
    let nextElementSibling = carouselGliders.nextElementSibling;
    while (nextElementSibling) {
        nextElementSibling.style.display = DISPLAY_NONE;
        nextElementSibling = nextElementSibling.nextElementSibling;
    }
}

export { initCarousel };